<template>
	<div class="">
		<Header @toggleLang="toggleLang" @toggleNext="toggleNext"></Header>
		<div class="layout m-hxbk">
			<div class="hxbk_count no-padding-top">
				<div class="wow fadeInUp animated" data-wow-delay="0.5s" data-wow-offset='0'>
					<img class="list_img" :src="zidiyiData" />
				</div>
				<div class="pro-container">
					<div class="pro-container_left">
						<div class="theme-black">
							<el-carousel indicator-position="none" height="640px" :interval="5000">
								<el-carousel-item v-for="(item,index) in tagexingData.files" :key="index">
									<div class="theme">
										<el-image @click="go_open(tagexingData.outlink)" class="pic"
											:src="item.includes('http')? item :prod+item" alt="踏歌行">
										</el-image>
									</div>
								</el-carousel-item>
							</el-carousel>
						</div>
						<div class="list_info">
							<div class="info_tit">
								<div class="tit_left">
									<span>商城</span>
									<el-divider direction="vertical"></el-divider>
									<span class="text-uppercase">Shopping Mall</span>
								</div>
							</div>
						</div>
						<div class="row" v-if="proList.length>0">
							<div class="item col-xs-4 col-lg-4" v-for="(item,index) in proList">
								<a :href="item.outlink" target="_blank">
									<div class="photos">
										<img class="photo" :src="item.image" />
										<div class="ewm css3"><img :src="item.ewm" /></div>
										<div class="mask css3"></div>
									</div>
									<div class="title line-2">{{item.title}}</div>
								</a>
							</div>
						</div>
						<div class="row" v-else>
							暂无数据~
						</div>
						<!-- 分页 -->
						<div class="fenye">
							<el-pagination @size-change="yshandleSizeChange" @current-change="yshandleCurrentChange"
								:current-page="yscurrentPage" background :page-size="per_page"
								layout="total, prev, pager, next, jumper" :total="total">
							</el-pagination>
						</div>
					</div>
					<div class="pro-container_right">
						<!-- 列表 -->
						<div class="subject_count_right">
							<div class="commo_div">
								<span class="text-uppercase">{{lang=='CN' ?'商城列表':'Shopping list'}}</span>
							</div>
							<div class="black">
								<div v-for="(item,index) in companyList" class="black_list pointer"
									:class="curr==index?'active':''" @click="show_zb_list(index)">
									<div class="commo_div_list">
										<span>{{lang=='CN' ?item.cn_name:item.en_name}}</span>
									</div>
								</div>
							</div>
						</div>
						<div class="subject_count_right">
							<div class="commo_div">
								<span class="text-uppercase">{{lang=='CN' ?'收藏品列表':'Collectibles list'}}</span>
							</div>
							<div class="black">
								<div v-for="(item,index) in categoryList" class="black_list pointer"
									:class="curr2==index?'active':''" @click="go_list(item.id)">
									<div class="commo_div_list">
										<span class="line-1">{{lang=='CN' ?item.cn_name:item.en_name}}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
	import Header from '@/components/Header'
	import Footer from '@/components/Footer'
	import {archives_list,add_pv,cb_company,get_file_all,product_list,channel_list} from '@/api/api.js'
	import {WOW} from 'wowjs'
	export default {
		components: {Header,Footer},
		name: 'coreplate',
		data() {
			return {
				currentPage4: 1,
				yscurrentPage: 1,
				parent_id: 9,
				zidiyiData: '',
				type: false,
				per_page: 9,
				page: 1,
				proList: [], //商品列表
				total: 0,
				company_id: 6, //公司ID
				lang: localStorage.getItem('lang') || 'CN',
				companyList: [],
				categoryList: [],
				
				curr: -1,
				tagexingData: {
					files: ''
				},
				prod:this.prod || 'http://www.jiaxinhaitan.com',
				artThreeList: [] //收藏品列表
			}
		},
		mounted() {
			this.company_id = this.$route.query.id
			if (typeof(this.$route.query.curr) == "number") {
				this.curr = this.$route.query.curr
				this.newCurr = this.$route.query.curr
				this.type = true
			}
			this.getZidiyiData() //自定义图片
			let data = {
				parent_id: this.company_id
			}
			this.addLocatPath()
			if(this.company_id){
				this.getProductList(this.company_id)
			}
			this.getCompanyList()


			this.getArchivesList26(82, 4)
			var wow = new WOW({
				boxClass: 'wow',
				animateClass: 'animated',
				offset: 0,
				mobile: true,
				live: true
			});
			wow.init();
			this.getCateglory()
		},
		methods: {
			go(id) {
				this.$router.push({
					path: `new_detail?id=${id}`
				})
			},
			
			
			getCateglory() {
				//获取二级栏目
				channel_list({
					parent_id: 0
				}).then(res => {
					if (res.code == 1) {
						let temp=res.data.filter(fil=>fil.model_tag==='collect')
						this.categoryList = temp
					}
				}).catch(err => {});
			
			},
			//跳转更多
			go_list(id) {
				this.$router.push({
					path: `list`,
					query: {
						parent_id: this.parent_id,
						id: id
					}
				})
			},
			//本页面所有文章列表
			getArchivesList26(id, type) {
				console.log("26本页面所有文章列表", id, type);
				let data = {
					channel_id: id,
					per_page: this.per_page,
					page: this.page
				}
				archives_list(data).then((res) => {
					if (res.code == 1) {
						this.artThreeList = res.data.data
						this.total = res.data.total
					}
				}).catch(err => {});
			},
			show_zb_list(num) {
				console.log(this.companyList);
				if (this.curr != num) {
					this.curr = num
					this.getProductList(this.companyList[num].id)
					let new_http = window.location.origin
					if (new_http == this.prod) {
						new_http = this.prod+'/web/'
					}
					let url = new_http + `#/shop?id=${this.companyList[num].id}`
					window.history.replaceState(null, '', url);
				}
			},
			//获取侧边公司列表
			getCompanyList() {
				let data = {}
				cb_company(data).then((res) => {
					this.companyList = res.data
				}).catch(err => {})
			},
			toggleLang(str) {
				localStorage.setItem('lang', str)
				this.lang = str
			},
			addLocatPath() {
				let data = {
					directions: '品牌商城',
					path: window.location.href
				}
				add_pv(data).then((res) => {}).catch(err => {});
			},
			// 获取自定义图片
			getZidiyiData() {
				let data = {}
				get_file_all(data).then((res) => {
					this.zidiyiData = res.data.center_part.files
					this.tagexingData = res.data.tagexing
					// console.log("==", this.tagexingData.files);
					let temp = temp = this.tagexingData.files.split(',')
					this.tagexingData.files = temp
				}).catch(err => {});
			},
			getProductList(id) {
				console.log("id",id);
				let data = {
					company_id: id,
					per_page: this.per_page,
					page: this.page
				}
				product_list(data).then((res) => {
					if (res.code == 1) {
						this.proList = res.data.data
						this.total = res.data.total
					}
				}).catch(err => {});
			},
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`)
			},
			handleCurrentChange(val) {
				this.page = val
				// this.detail(this.jx_index)
				this.getProductList(this.jx_index)
				console.log(`当前页: ${val}`)
			},
			yshandleSizeChange(val) {
				console.log(`每页 ${val} 条`)
			},
			yshandleCurrentChange(val) {
				this.page = val
				// this.detail(this.jx_index)
				this.getProductList(this.jx_index)
				console.log(`当前页: ${val}`)
			}
		}
	}
</script>
<style scoped lang="scss">
	.m-hxbk {
		.hxbk_count {
			.pro-container {
				margin: 50px auto 0;
				max-width: 1400px;
				overflow: hidden;
				display: flex;

				&_left {
					width: 1080px;

					.theme-black {
						width: 1080px;
						height: 640px;
						margin-bottom: 100px;
					}

					.theme {
						width: 1080px;
						height: 640px;
						margin-bottom: 100px;

						.pic {
							width: 100%;
							height: 100%;
						}
					}

					.list_info {
						margin: 0px auto 30px auto;
						max-width: 1400px;

						.info_tit {
							.tit_left {
								span:first-child {
									font-size: 30px;
									color: #000;
									font-weight: bold;
									line-height: 33px;
								}

								span:last-child {
									font-size: 14px;
									color: #999;
								}
							}
						}
					}
				}

				&_right {
					width: 320px;

					.subject_count_right {
						float: right;
						width: 260px;
						margin-bottom: 40px;

						.commo_div {
							background: #006170;
							display: flex;
							flex-direction: row;
							justify-content: center;
							padding: 15px 20px;
							color: #fff;
							align-items: center;
							margin-bottom: 10px;
							cursor: pointer;
						}

						.black {
							background: #F0F4F5;

							.black_list {
								border-bottom: 0.5px solid #E5E5E5;

								.commo_div {
									background: #006170;
									display: flex;
									flex-direction: row;
									justify-content: center;
									padding: 15px 20px;
									color: #fff;
									align-items: center;
									margin-bottom: 10px;
									cursor: pointer;

									&_list {
										padding: 15px 20px;
										color: #000000;
										display: flex;
										justify-content: center;
									}
								}
							}

							.black_list:last-child {
								border-bottom: 0px solid #E5E5E5;
							}

							.active {
								background: #fff;
								box-shadow: 2px 8px 10px 0px rgba(0, 66, 77, 0.2);

								.commo_div_list {
									color: #006170;
								}
							}
						}
					}
				}
			}
		}
	}

	a:hover {
		text-decoration: none;
	}

	.hxbk_count {
		padding: 30px;
	}

	.fenye {
		margin-top: 50px;
		text-align: center;
	}

	.el-pagination.is-background .el-pager li:not(.disabled).active {
		background-color: #006170;
	}

	.item {
		overflow: hidden;
		position: relative;
		margin-bottom: 25px;

		.photos {
			width: 100%;
			height: 320px;
			position: relative;
			overflow: hidden;

			.photo {
				width: 100%;
				object-fit: cover;
				height: 400px;

			}


		}

	}

	.mask {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 2;
		opacity: 0;
		background: rgba(0, 0, 0, .5);
	}

	.pro-container:hover .mask {
		opacity: 1;
	}

	.pro-container:hover .item:hover .mask {
		opacity: 0;
	}

	.pointer:hover {
		cursor: pointer;
		background: #fff;
		-webkit-box-shadow: 2px 8px 10px 0px rgba(0, 66, 77, 0.2);
		box-shadow: 2px 8px 10px 0px rgba(0, 66, 77, 0.2);
	}

	.item .ewm {
		width: 140px;
		height: 140px;
		position: absolute;
		top: 50%;
		left: 50%;
		z-index: 3;
		margin: -70px 0 0 -70px;
		transform: scale(0);
		-webkit-transform: scale(0);
		-moz-transform: scale(0);
		-o-transform: scale(0);
		-ms-transform: scale(0);
		img {
			width: 140px;
			height: 140px;
			object-fit: cover;
		}
	}

	.item:hover .ewm {

		transform: scale(1);
		-webkit-transform: scale(1);
		-moz-transform: scale(1);
		-o-transform: scale(1);
		-ms-transform: scale(1);

	}

	.title {
		margin-top: 10px;
		height: 60px;
		line-height: 30px;
		color: #333333;
		font-size: 18px;
	}

	.title:hover {
		color: #006170;
		cursor: pointer;
	}

	@media screen and (min-width: 1200px) and (max-width: 1399px) {
		.item img {
			height: 300px;
		}
	}

	@media screen and (min-width: 899px) and (max-width: 1199px) {
		.item img {
			height: 250px;
		}
	}
</style>
